module.exports = __webpack_public_path__ + "img/valur.dc68e0de.png";